import { useState, useEffect } from 'react';
import Marquee from 'react-fast-marquee';
import { TrendingUp, TrendingDown } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function StockTicker() {
  const [stocks, setStocks] = useState([]);

  useEffect(() => {
    fetchStocks();
  }, []);

  const fetchStocks = async () => {
    try {
      const response = await axios.get(`${API}/stocks`);
      setStocks(response.data);
    } catch (error) {
      setStocks([
        { symbol: 'AAPL', name: 'Apple Inc.', price: 252.85, change: -2.91, change_percent: -1.14 },
        { symbol: 'TSLA', name: 'Tesla Inc.', price: 395.26, change: 0.25, change_percent: 0.06 },
        { symbol: 'AMZN', name: 'Amazon.com', price: 207.90, change: -1.63, change_percent: -0.78 },
        { symbol: 'META', name: 'Meta Platforms', price: 618.22, change: -19.96, change_percent: -3.13 },
        { symbol: 'MSFT', name: 'Microsoft Corp', price: 396.42, change: -5.44, change_percent: -1.35 },
        { symbol: 'NVDA', name: 'NVIDIA Corp', price: 181.30, change: -1.84, change_percent: -1.00 },
        { symbol: 'BTC', name: 'Bitcoin/USD', price: 71818.85, change: 1287.29, change_percent: 1.83 },
        { symbol: 'ETH', name: 'Ether/USD', price: 2132.20, change: 58.20, change_percent: 2.81 },
      ]);
    }
  };

  const formatPrice = (price) => {
    if (price >= 1000) {
      return price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    return price.toFixed(2);
  };

  return (
    <div className="stock-ticker py-2" data-testid="stock-ticker">
      <Marquee gradient={false} speed={40} pauseOnHover>
        {stocks.map((stock, index) => (
          <div
            key={`${stock.symbol}-${index}`}
            className="ticker-item flex items-center space-x-3 px-6"
          >
            <span className="font-mono text-sm font-medium text-gray-900">
              {stock.symbol}
            </span>
            <span className="font-mono text-sm text-gray-500">
              ${formatPrice(stock.price)}
            </span>
            <span
              className={`flex items-center font-mono text-xs ${
                stock.change >= 0 ? 'text-emerald-700' : 'text-red-600'
              }`}
            >
              {stock.change >= 0 ? (
                <TrendingUp className="w-3 h-3 mr-1" strokeWidth={1.5} />
              ) : (
                <TrendingDown className="w-3 h-3 mr-1" strokeWidth={1.5} />
              )}
              {stock.change >= 0 ? '+' : ''}
              {stock.change_percent.toFixed(2)}%
            </span>
          </div>
        ))}
      </Marquee>
    </div>
  );
}
